import { IPermissions } from "./ipermissions.interface";
import { pageOwnerPolicy } from "../policies/record-policy/page-owner.policy";
import { merchOwnerPolicy } from "../policies/record-policy/merch-owner.policy";
import { contentCreatorPolicy } from "../policies/record-policy/content-creator.policy";
import { reviewerPolicy } from "../policies/record-policy/reviewer.policy";
import { adminGroupPolicy } from "../policies/group-policy/admin-group.policy";
import { productionDirectorGroupPolicy } from "../policies/group-policy/production-director-group.policy";
import { campaignManagerGroupPolicy } from "../policies/group-policy/campaign-manager-group.policy";
import { executionManagerGroupPolicy } from "../policies/group-policy/execution-manager-group.policy";
import { workOrderManagerGroupPolicy } from "../policies/group-policy/work-order-manager-group.policy";
import { inventoryReviewerGroupPolicy } from "../policies/group-policy/inventory-reviewer-group.policy";
import { channelPrimesGroupPolicy } from "../policies/group-policy/channel-primes-group.policy";
import { contentCreatorGroupPolicy } from "../policies/group-policy/content-creator-group.policy";
import { marketingDirectorsGroupPolicy } from "../policies/group-policy/marketing-directors-group.policy";
import { IPermissionsContext } from "../ipermissions-context/ipermissions-context.interface";
import { generalUserGroupPolicy } from "../policies/group-policy/general-user-group.policy";
import { productionCoordinatorGroupPolicy } from "../policies/group-policy/production-coordinator-group.policy";

export function canUpdateReviewStatus(permissions: IPermissions): boolean {
  return permissions.updateReviewStatus;
}

export function canManageReviewers(permissions: IPermissions): boolean {
  return permissions.manageReviewers;
}

export function canManageStatus(permissions: IPermissions): boolean {
  return permissions.manageStatus;
}

export function enablePermissionIf(
  permissions: IPermissions,
  condition: boolean,
  property: keyof IPermissions
): IPermissions {
  if (condition) {
    return enablePermissions(permissions, property);
  }
  return permissions;
}

export function setPermissions(
  permissions: IPermissions,
  value: boolean,
  ...properties: (keyof IPermissions)[]
): IPermissions {
  for (const property of properties) {
    permissions[property] = value;
  }
  return permissions;
}

export function enablePermissions(
  permissions: IPermissions,
  ...properties: (keyof IPermissions)[]
): IPermissions {
  return setPermissions(permissions, true, ...properties);
}

export function createUserPermissions(): IPermissions {
  return {
    canView: true,
    canEdit: false,
    canArchive: false,
    canDelete: false,
    manageProducts: false,
    manageReviewers: false,
    manageCampBriefs: false,
    manageExecBriefs: false,
    manageWorkOrders: false,
    manageStatus: false,
    updateReviewStatus: false,
    canCreateFlyer: false,
  };
}

export function calculatePermissions(context: IPermissionsContext): IPermissions {
  const userPermissions = createUserPermissions();

  return executePermissionsPolicyChains(
    [createRecordPolicyChain(), createGroupPolicyChain()],
    context,
    userPermissions
  );
}

function createRecordPolicyChain() {
  return pageOwnerPolicy(merchOwnerPolicy(contentCreatorPolicy(reviewerPolicy())));
}

function createGroupPolicyChain() {
  return adminGroupPolicy(
    productionDirectorGroupPolicy(
      productionCoordinatorGroupPolicy(
        generalUserGroupPolicy(
          campaignManagerGroupPolicy(
            executionManagerGroupPolicy(
              workOrderManagerGroupPolicy(
                inventoryReviewerGroupPolicy(
                  channelPrimesGroupPolicy(
                    contentCreatorGroupPolicy(marketingDirectorsGroupPolicy())
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}

function executePermissionsPolicyChains(
  policyChains: any[],
  context: IPermissionsContext,
  permissions: IPermissions
) {
  for (const chain of policyChains) {
    chain(context, permissions);
  }
  return permissions;
}
